import { platformApi } from "@/api/http";

export interface WorkHour {
  id: number;
  businessId: number;
  userId: number;
  dayOfWeek: string;
  enabled: boolean;
  startTime: string | null;
  endTime: string | null;
}

export interface WorkHourUpdate {
  enabled: boolean;
  startTime?: string | null;
  endTime?: string | null;
}

const DAY_ORDER: Record<string, number> = {
  MONDAY: 1, TUESDAY: 2, WEDNESDAY: 3, THURSDAY: 4,
  FRIDAY: 5, SATURDAY: 6, SUNDAY: 7,
};

export const workHoursApi = {
  getMyWorkHours: async (): Promise<WorkHour[]> => {
    const { data } = await platformApi.get<WorkHour[]>("/api/v1/users/me/work-hours");
    const arr = Array.isArray(data) ? data : [];
    return arr.sort((a, b) => (DAY_ORDER[a.dayOfWeek] ?? 8) - (DAY_ORDER[b.dayOfWeek] ?? 8));
  },

  updateMyWorkHour: async (id: number, update: WorkHourUpdate): Promise<WorkHour> => {
    const { data } = await platformApi.put<WorkHour>(`/api/v1/users/me/work-hours/${id}`, update);
    return data;
  },
};
